import React from 'react'

const Footer = () => {
  return (
    <div className='foot d-flex align-items-center justify-content-center bg-dark text-light p-4 mt-4' style={{textAlign:'center'}}>
        <h6>ReactJS | Firebase | HTML | CSS<br/>
        Abhay Pratap Singh<br/>
        Copyright @ 2023
        </h6>
    </div>
  )
}

export default Footer 